<template>
  <div id="app">
    <transition name="fade" :duration="200">
      <router-view />
    </transition>
    <div v-if="notifications !== null" class="notification-container">
      <transition-group name="slide" tag="div" class="notification-group">
        <Notification
          v-for="notification in notifications"
          :key="notification.id"
          :type="notification.type"
        >
          {{ notification.message }}
        </Notification>
      </transition-group>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Notification from '@/components/Notification.vue'

export default {
  name: 'App',
  components: { Notification },
  computed: mapState('notifications', {
    notifications: 'activeNotifications'
  })
}
</script>

<style lang="scss">
html {
  font-size: $base-font-size;
}

body {
  padding: 0;
  margin: 0;
  color: $base-text-color;
}

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100vw;
  height: 100vh;
  background: linear-gradient(-9deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.05));
  position: relative;
}

.fade-enter-active, .fade-leave-active {
  transition: opacity .2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}

.notification-container {
  width: 25vw;
  position: absolute;
  top: 0;
  left: 50%;
  margin-left: -12.5vw;
}

.notification-group {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: stretch;

  .notification {
    z-index: 1001;
  }
}

.slide-leave-active {
  position: absolute;
  left: 0;
  right: 0;
  z-index: 1000;
}

.slide-enter, .slide-leave-to {
  transform: translateY(-100%);
}

span.logo {
  font-size: 1.5em;
  line-height: 1;
  font-family: 'Poetica', serif;
  text-transform: lowercase;
}
</style>
